<div id="presentationPropertiesModal">
  <div class="tw-flex tw-justify-end tw-mr-2">
    <button
      id="dismissButton"
      mat-icon-button
      type="button"
      class="close"
      [mat-dialog-close]="false"
      aria-label="Close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>
  <h4 class="tw-text-center">Presentation Properties</h4>
  <form
    #presentationPropertiesForm="ngForm"
    id="presentationPropertiesForm"
    role="form"
    name="forms.presentationPropertiesForm"
    novalidate
  >
    <mat-dialog-content>
      <div class="form-group" [shown]="presentationProperties.id">
        <label>Presentation Id:</label>
        <p id="presentationId">{{ presentationProperties.id }}</p>
      </div>
      <!--form-group-->
      <div class="form-group">
        <div class="flex-row">
          <mat-checkbox
            name="sharePresentation"
            [(ngModel)]="presentationProperties.isTemplate"
            ngDefaultControl
            [disabled]="
              !sharedTemplatesAvailable && !presentationProperties.isTemplate
            "
          ></mat-checkbox>
          <span
            class="font-weight-bold mr-3"
            [ngClass]="{
              'control-label': sharedTemplatesAvailable,
              'u_link-disabled': !sharedTemplatesAvailable,
            }"
            >Share this Presentation with your Sub-Companies</span
          >
        </div>
        <div class="ml-5" [shown]="!sharedTemplatesAvailable">
          <span [shown]="sharedTemplatesAvailable === null">
            <a
              href="#"
              class="madero-link"
              uiSref="apps.purchase.home"
              (click)="dismiss()"
              >Subscription Required</a
            >
          </span>
          <span [shown]="sharedTemplatesAvailable !== null">
            <a actionLink class="madero-link" (click)="showUpgradePlanModal()"
              >Plan Upgrade Required</a
            >
          </span>
        </div>
      </div>
      <rv-divider />
      <div class="form-group">
        <label id="resolutionLabel">Resolution:</label>
        <resolution-selector
          [(width)]="presentationProperties.width"
          [(height)]="presentationProperties.height"
        ></resolution-selector>
      </div>
      <!--form-group-->
      <div class="form-group">
        <label id="backgroundLabel">Background:</label>
        <background-image
          id="backgroundImageSettings"
          [background]="presentationProperties.background"
          [companyId]="companyId"
        ></background-image>
      </div>
      <div class="form-group">
        <label id="playUntilDonePlaceholderLabel" class="control-label"
          >Play Until Done Placeholder:</label
        >
        <select
          name="playUntilDonePlaceholder"
          id="playUntilDonePlaceholderSelect"
          class="form-control"
          [(ngModel)]="presentationProperties.donePlaceholder"
        >
          @for (placeholder of placeholders; track placeholder) {
            <option value="{{ placeholder.id }}">{{ placeholder.id }}</option>
          }
        </select>
      </div>
      <!--form-group-->
      <div class="form-group">
        <div class="flex-row">
          <mat-checkbox
            name="hideMousePointer"
            id="hideMousePointerCheckbox"
            [(ngModel)]="presentationProperties.hidePointer"
            ngDefaultControl
          ></mat-checkbox>
          <span id="hideMousePointerCheckboxLabel" class="control-label mr-3"
            >Hide Mouse Pointer</span
          >
        </div>
      </div> </mat-dialog-content
    ><!--modal-body-->
    <mat-dialog-actions align="end" class="tw-gap-4">
      <button
        id="presentationPropertiesCancelButton"
        type="button"
        matButton="outlined"
        [mat-dialog-close]="false"
      >
        Cancel
      </button>
      <button
        id="applyButton"
        type="submit"
        mat-flat-button
        color="primary"
        (click)="apply()"
        [disabled]="presentationPropertiesForm?.invalid"
      >
        Apply
      </button>
    </mat-dialog-actions>
  </form>
</div>
